export const PASSWORD_REQUIREMENTS = [
  {
    name: '6 characters minimum ',
    pattern: /(?=.{6,})/g
  },
  {
    name: 'One uppercase letter',
    pattern: /(?=.*[A-Z])/g
  },
  {
    name: 'One number',
    pattern: /(?=.*\d)/g
  },
  {
    name: 'One special character !@#$%^&*',
    // Every character the hint names, plus ?, which passed before (QA.20).
    pattern: /(?=.*[!@#$%^&*?])/g
  }
];
